import React from "react";
import Quiz from "../Quiz";

const questions = [
  {
    questionText: "What are the two main groups of things in nature?",
    options: ["Living and non-living", "Big and small", "Water and air"],
    correct: "Living and non-living",
  },
  {
    questionText: "Which of these is a living thing?",
    options: ["Rock", "Tree", "Water"],
    correct: "Tree",
  },
  {
    questionText: "What is the difference between living and non-living things?",
    options: ["Living things are bigger", "Living things are smaller", "Living things can move and grow"],
    correct: "Living things can move and grow",
  },
  {
    questionText: "What do plants need to grow?",
    options: ["Water and sunlight", "Soil and food", "Air and shelter"],
    correct: "Water and sunlight",
  },
  {
    questionText: "Which do living things need to grow?",
    options: ["Food, water, air", "Food, shelter, love", "Water, shelter, air", "Food, water, sunlight"],
    correct: "Food, water, sunlight",
  },
  {
    questionText: "What do roots do for a plant?",
    options: ["Make food", "Absorb water", "Help flowers bloom"],
    correct: "Absorb water",
  },
  {
    questionText: "What is the purpose of a flower within plant life?",
    options: ["Make seeds", "Make water", "Grow roots"],
    correct: "Make seeds",
  },
  {
    questionText: "What is photosynthesis?",
    options: [
      "When plants drink water",
      "When green plants make there own food using sunlight and Oxygen using Chlororphyll",
      "When plants breathe",
    ],
    correct: "When plants make food using sunlight",
  },
  {
    questionText: "What helps animals move and protects their bodies?",
    options: ["Muscles", "Fur", "Skeleton"],
    correct: "Skeleton",
  },
  {
    questionText: "What is a vertebrate?",
    options: [
      "An animal with a backbone",
      "An animal with wings",
      "An animal with no legs",
    ],
    correct: "An animal with a backbone",
  },
  {
    questionText: "Which of these is an invertebrate?",
    options: ["Dog", "Worm", "Bird"],
    correct: "Worm",
  },
  {
    questionText: "What is an ecosystem?",
    options: [
      "A place with only animals",
      "A forest",
      "A mix of living and non-living things working together",
    ],
    correct: "A mix of living and non-living things working together",
  },
  {
    questionText: "Which one is NOT part of an ecosystem?",
    options: ["Sunlight", "Table", "Plant"],
    correct: "Table",
  },
  {
    questionText: "What is the purpose of decomposers?",
    options: [
      "Make food for animals",
      "Recycle dead plants and animals",
      "Eat sunlight",
    ],
    correct: "Recycle dead plants and animals",
  },
  {
    questionText: "Which of the following organisms make there own food?",
    options: ["Lion", "Grass", "Mouse"],
    correct: "Grass",
  },
  {
    questionText: "Which of the following is a characteristic of invertebrates?",
    options: ["Presence of a backbone", "Absence of a backbone", "Presence of internal skeleton", "Absence of internal skeleton"],
    correct: "Absence of a backbone",
  },
  {
    questionText: "What is the correct order in a food chain?",
    options: [
      "Producer → Consumer → Decomposer",
      "Consumer → Producer → Decomposer",
      "Decomposer → Producer → Consumer",
    ],
    correct: "Producer → Consumer → Decomposer",
  },
];

export default function NaturalScienceQuiz({ studentInfo, onComplete }) {
  return <Quiz studentInfo={studentInfo} questions={questions} onComplete={onComplete} />;
}


